import { setAttr } from '@utils/setAttr';
import { BreakingText } from '@components/Text/TruncatedText';
import {
  TooltipTextWrap,
  TooltipContentDiv,
} from './DocumentTooltipContent.styles';

export interface DocumentTooltipContent {
  description: string | null;
  value: string;
}
export function DocumentTooltipContent(props: DocumentTooltipContent) {
  const { description, value } = props;
  const hasDescription = !!description;
  return (
    <TooltipContentDiv>
      <TooltipTextWrap data-hasdescription={setAttr(hasDescription)}>
        <BreakingText text="h500">{value}</BreakingText>
      </TooltipTextWrap>
      {hasDescription && <BreakingText text="p100">{description}</BreakingText>}
    </TooltipContentDiv>
  );
}
